/**
 * Fashion outfits (lane C0-OUTFIT, user-approved 2026-10-10; research docs/research/C0_OUTFITS.md, review
 * docs/review/c0-outfits/): ten full-body outfits, each for a man and a woman, as rig uniforms — one layer per slot
 * (top, bottom, robe, shoes, belt, cape, pauldrons, headwear, ornaments) so they split into parts for free
 * customisation — plus the outline-breaking parts (flowParts.ts: flying scarf, shoulder drape, wide sleeves).
 * Worn through the look's `fashion` (the fashion skins `fashion-<id>`, looks/outfits.ts; sets.ts `appearanceOf`),
 * in place of the clothes and school uniform; the wearer keeps their own face, weapon and (unless the outfit sets
 * one) hairstyle. Garment types are costume history; colourways and combinations are our own.
 */
import { extraLayer } from './flowParts';
import type { Layer } from './figure';
import { uniformLayers } from './uniforms';
import { FASHION, type OutfitBody, type OutfitDesign } from './fashionData';

export { FASHION, type OutfitBody, type OutfitDesign } from './fashionData';

export const FASHION_BY_ID: Readonly<Record<string, OutfitDesign>> = Object.fromEntries(
  FASHION.map((d) => [d.id, d]),
);

/** An outfit body's clothes as layers: the uniform's slots, then its outline-breaking parts. */
export function fashionLayers(b: OutfitBody): Layer[] {
  return [...uniformLayers(b), ...(b.extras ?? []).map(extraLayer)];
}
